import { useMemo, useState } from 'react';
import { FeatureSet, FeatureSetMap } from '~pricing/lib/summaryPackages';
import { convertFeatureSetToMap } from '~pricing/lib/lib-helpers';

export default function usePackageFeatureSet(featureSet: FeatureSet): FeatureSetMap {
  const [featureSetMap, setFeatureSetMap] = useState<FeatureSetMap>({});
  useMemo(() => {
    setFeatureSetMap(convertFeatureSetToMap(featureSet));
  }, [featureSet]);

  return featureSetMap;
}
